"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrcadDsnCfbTypes = void 0;
var OrcadDsnCfbTypes;
(function (OrcadDsnCfbTypes) {
    let PinNameSource;
    (function (PinNameSource) {
        PinNameSource["Record"] = "record";
        PinNameSource["SymbolPin"] = "symbol_pin";
    })(PinNameSource = OrcadDsnCfbTypes.PinNameSource || (OrcadDsnCfbTypes.PinNameSource = {}));
    let PlacementReferenceState;
    (function (PlacementReferenceState) {
        PlacementReferenceState["Resolved"] = "resolved";
        PlacementReferenceState["Withheld"] = "withheld";
    })(PlacementReferenceState = OrcadDsnCfbTypes.PlacementReferenceState || (OrcadDsnCfbTypes.PlacementReferenceState = {}));
    let PlacementValueState;
    (function (PlacementValueState) {
        PlacementValueState["Withheld"] = "withheld";
    })(PlacementValueState = OrcadDsnCfbTypes.PlacementValueState || (OrcadDsnCfbTypes.PlacementValueState = {}));
    let OrCadDsnCfbSymbolPinType;
    (function (OrCadDsnCfbSymbolPinType) {
        OrCadDsnCfbSymbolPinType[OrCadDsnCfbSymbolPinType["Power"] = 7] = "Power";
    })(OrCadDsnCfbSymbolPinType = OrcadDsnCfbTypes.OrCadDsnCfbSymbolPinType || (OrcadDsnCfbTypes.OrCadDsnCfbSymbolPinType = {}));
    let OrCadDsnCfbSymbolPinDisplayFlag;
    (function (OrCadDsnCfbSymbolPinDisplayFlag) {
        OrCadDsnCfbSymbolPinDisplayFlag[OrCadDsnCfbSymbolPinDisplayFlag["IsLong"] = 1] = "IsLong";
        OrCadDsnCfbSymbolPinDisplayFlag[OrCadDsnCfbSymbolPinDisplayFlag["IsClock"] = 2] = "IsClock";
        OrCadDsnCfbSymbolPinDisplayFlag[OrCadDsnCfbSymbolPinDisplayFlag["IsDot"] = 4] = "IsDot";
        OrCadDsnCfbSymbolPinDisplayFlag[OrCadDsnCfbSymbolPinDisplayFlag["IsLeftPointing"] = 8] = "IsLeftPointing";
        OrCadDsnCfbSymbolPinDisplayFlag[OrCadDsnCfbSymbolPinDisplayFlag["IsRightPointing"] = 16] = "IsRightPointing";
        OrCadDsnCfbSymbolPinDisplayFlag[OrCadDsnCfbSymbolPinDisplayFlag["IsVisible"] = 32] = "IsVisible";
        OrCadDsnCfbSymbolPinDisplayFlag[OrCadDsnCfbSymbolPinDisplayFlag["IsHidden"] = 128] = "IsHidden";
    })(OrCadDsnCfbSymbolPinDisplayFlag = OrcadDsnCfbTypes.OrCadDsnCfbSymbolPinDisplayFlag || (OrcadDsnCfbTypes.OrCadDsnCfbSymbolPinDisplayFlag = {}));
    OrcadDsnCfbTypes.ORCAD_DSN_CFB_KNOWN_SYMBOL_PIN_DISPLAY_FLAGS = OrCadDsnCfbSymbolPinDisplayFlag.IsLong |
        OrCadDsnCfbSymbolPinDisplayFlag.IsClock |
        OrCadDsnCfbSymbolPinDisplayFlag.IsDot |
        OrCadDsnCfbSymbolPinDisplayFlag.IsLeftPointing |
        OrCadDsnCfbSymbolPinDisplayFlag.IsRightPointing |
        OrCadDsnCfbSymbolPinDisplayFlag.IsVisible |
        OrCadDsnCfbSymbolPinDisplayFlag.IsHidden;
    let OrCadDsnCfbMetadataFieldState;
    (function (OrCadDsnCfbMetadataFieldState) {
        OrCadDsnCfbMetadataFieldState["stated"] = "stated";
        OrCadDsnCfbMetadataFieldState["empty"] = "empty";
        OrCadDsnCfbMetadataFieldState["malformed"] = "malformed";
    })(OrCadDsnCfbMetadataFieldState = OrcadDsnCfbTypes.OrCadDsnCfbMetadataFieldState || (OrcadDsnCfbTypes.OrCadDsnCfbMetadataFieldState = {}));
    let HierarchyOwnershipState;
    (function (HierarchyOwnershipState) {
        HierarchyOwnershipState["Resolved"] = "resolved";
        HierarchyOwnershipState["Withheld"] = "withheld";
    })(HierarchyOwnershipState = OrcadDsnCfbTypes.HierarchyOwnershipState || (OrcadDsnCfbTypes.HierarchyOwnershipState = {}));
    let HierarchyBranchDecodeState;
    (function (HierarchyBranchDecodeState) {
        HierarchyBranchDecodeState["Resolved"] = "resolved";
        HierarchyBranchDecodeState["Withheld"] = "withheld";
        HierarchyBranchDecodeState["Unframed"] = "unframed";
        HierarchyBranchDecodeState["Incomplete"] = "incomplete";
    })(HierarchyBranchDecodeState = OrcadDsnCfbTypes.HierarchyBranchDecodeState || (OrcadDsnCfbTypes.HierarchyBranchDecodeState = {}));
})(OrcadDsnCfbTypes || (exports.OrcadDsnCfbTypes = OrcadDsnCfbTypes = {}));
//# sourceMappingURL=OrcadDsnCfbTypes.js.map